import { render, staticRenderFns } from "./GroupAccountSelector.vue?vue&type=template&id=a1b3b606&scoped=true"
import script from "./GroupAccountSelector.vue?vue&type=script&lang=js"
export * from "./GroupAccountSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupAccountSelector.vue?vue&type=style&index=0&id=a1b3b606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b3b606",
  null
  
)

export default component.exports